var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFile = function SvgIconFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 1.868a4.015 4.015 0 0 0-5.656 0L3.429 9.293c-2.14 2.14-2.14 5.639 0 7.778 2.14 2.14 5.639 2.14 7.778 0l6.01-6.01a1 1 0 0 0-1.414-1.415l-6.01 6.01a3.485 3.485 0 0 1-4.95 0 3.485 3.485 0 0 1 0-4.949l7.425-7.425c.79-.79 2.039-.79 2.828 0 .79.79.79 2.04 0 2.829l-7.424 7.425a.487.487 0 0 1-.708 0 .487.487 0 0 1 0-.708l6.01-6.01a1 1 0 1 0-1.413-1.414l-6.01 6.01a2.515 2.515 0 0 0 0 3.536 2.515 2.515 0 0 0 3.535 0l7.424-7.425a4.015 4.015 0 0 0 0-5.657Z",
    fillRule: "nonzero"
  })));
};

export default SvgIconFile;